import axios from "axios";
import { API } from "@/App";

const withCreds = { withCredentials: true };

export async function getCoverageHealth() {
  const { data } = await axios.get(`${API}/coverage/health`, withCreds);
  return data;
}

export async function getCoverageReadiness() {
  const { data } = await axios.get(`${API}/coverage/readiness`, withCreds);
  return data;
}

export async function getCoveragePatient(patientId) {
  const { data } = await axios.get(`${API}/coverage/patients/${encodeURIComponent(patientId)}`, withCreds);
  return data;
}

export async function verifyCoveragePatient(patientId, appointmentId) {
  const body = {};
  if (appointmentId) body.appointment_id = appointmentId;
  const { data } = await axios.post(
    `${API}/coverage/patients/${encodeURIComponent(patientId)}/verify`,
    body,
    withCreds
  );
  return data;
}

export async function resolveCoverageReview(reviewId, { corrections = [], appointmentId, correctedBy } = {}) {
  const { data } = await axios.post(
    `${API}/coverage/reviews/${encodeURIComponent(reviewId)}/resolve`,
    {
      corrections,
      appointment_id: appointmentId || undefined,
      corrected_by: correctedBy || undefined,
    },
    withCreds
  );
  return data;
}
